import Vue from 'vue';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';
import { StateManager } from '../../domain/state-manager';
import State from '../../domain/state-manager/state';
import MatiVerificationState from '../../domain/state-manager/mati-verification-state';

@Injectable()
export default class VueStateManager implements StateManager {
  private _state: State = Vue.observable<State>(new State());

  // eslint-disable-next-line max-len
  private _mati_verification_state: MatiVerificationState = Vue.observable<MatiVerificationState>(new MatiVerificationState());

  private readonly observers: Observer[] = [];

  get state(): State {
    return this._state;
  }

  set state(value: State) {
    this._state = value;
    this.notifyAll();
  }

  get mati_verification_state(): MatiVerificationState {
    return this._mati_verification_state;
  }

  set mati_verification_state(value: MatiVerificationState) {
    this._mati_verification_state = value;
    this.notifyAll();
  }

  patch(state: Partial<State>) {
    type Keys = keyof State;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  patch_mati_verification_state(state: Partial<MatiVerificationState>) {
    type Keys = keyof MatiVerificationState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.mati_verification_state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
